var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-button',{staticClass:"concurrent--add",attrs:{"variant":"smooth","icon":"add","size":"tiny"},on:{"click":_vm.addConcurrent}},[_vm._v("\n  "+_vm._s(_vm.$t('CONTACT_PANEL.CONCURRENTS.CONVERSATION.ADD_BUTTON'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }